import styled from 'styled-components';

export const LogoSuffixContainer = styled.div`
  cursor: pointer;
`;
